/**
 * Boot-time check: UI formatting uses Intl with APP_TIMEZONE (see utils/timezoneDisplay.js).
 * Browser/OS timezone may differ; all displayed instants are formatted in Asia/Kolkata.
 */
import { APP_TIMEZONE } from './config/timezone';

try {
  new Intl.DateTimeFormat('en-IN', { timeZone: APP_TIMEZONE }).format(new Date());
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn(`[CRM] Intl time zone "${APP_TIMEZONE}" is not supported in this browser:`, e);
}
